(function() {
    'use strict';
    /*
     * Copyright (c) 2014-15 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .service('MemorySvc', MemorySvc);

    MemorySvc.$inject = ['$window'];

    /**
     * Manages storage of values based on key and spaces (namely local storage, session storage, and js storage).
     * Do not use <code>new</code> to create an instance. See the example below for how to use the service in a controller.
     * @ngdoc service
     * @name MemorySvc
     * @memberOf ihh-common-web
     * @example
     * // Declaring the MemorySvc service in a controller.
     * myModule.controller('MyCtrl', ['MemorySvc', ..., function(MemorySvc, ...) {
     *    ...
     * }
     */
    function MemorySvc($window) {
        var memory = this;

        memory.LOCAL = 'local';
        memory.SESSION = 'session';
        memory.JS = 'js';

        this.jsStorage = {
            jsStore: [],
            setItem : function(key, value) {
                this.jsStore[key] = value;
            },
            getItem : function(key) {
                return this.jsStore[key];
            },
            removeItem : function(key) {
                delete this.jsStore[key];
            },
            clear : function() {
                this.jsStore = [];
            }
        };

        /**
         * @function memorize
         * @memberOf ihh-common-web.MemorySvc
         * @description Memorizes the value for the specified key in the specified space.
         */
        this.memorize = function(space, key, value) {
            function set(storage, key, value) {
                storage.setItem(key, JSON.stringify(value));
            }

            if (space === memory.LOCAL) {
                set($window.localStorage, key, value);
            }
            else if (space === memory.SESSION) {
                set($window.sessionStorage, key, value);
            }
            else if (space === memory.JS) {
                set(memory.jsStorage, key, value);
            }
        };

        /**
         * @function recall
         * @memberOf ihh-common-web.MemorySvc
         * @description Recalls the value for the specified key in the specified space.
         * @returns {Object} the value
         */
        this.recall = function(space, key) {
            function get(storage, key) {
                var rawValue = storage.getItem(key);
                var value = angular.isDefined(rawValue) ? JSON.parse(rawValue) : rawValue;
                return value;
            }

            var recollection = null;
            if (space === memory.LOCAL) {
                recollection = get($window.localStorage, key);
            }
            else if (space === memory.SESSION) {
                recollection = get($window.sessionStorage, key);
            }
            else if (space === memory.JS) {
                recollection = get(memory.jsStorage, key);
            }
            return recollection;
        };

        /**
         * @function forget
         * @memberOf ihh-common-web.MemorySvc
         * @description Forgets the specified key in the specified space.
         */
        this.forget = function(space, key) {
            function remove(storage, key) {
                storage.removeItem(key);
            }

            if (space === memory.LOCAL) {
                remove($window.localStorage, key);
            }
            else if (space === memory.SESSION) {
                remove($window.sessionStorage, key);
            }
            else if (space === memory.JS) {
                remove(memory.jsStorage, key);
            }
        };
    }
})();